
const Utility = {
    /**
   * Email Validation
   * @param {*} email 
   */
  validateEmail(email){
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }
}

class customDesignForm {
    constructor() {
        this.container = document.querySelector('[data-requestFormParent]');
        this.form = document.querySelector('[data-designRequestForm]');
        this.submitBtn = document.querySelector('[data-designRequestForm] button[type="submit"]');
        this.thankyouScreen = document.querySelector('[data-requestFormParent] .thank_you_screen');
        this.scrollToFormBtns = document.querySelectorAll('[data-openCustomForm], a[href="#openCustomRequestForm"]');

        

        this._setupEventListeners();
    }
  
    _setupEventListeners() {
        this.form.addEventListener('submit', (evt)=>{
            evt.preventDefault();
            let validForm = this._validForSubmission();
            if(!validForm) return;

            this._submitForm(evt);
        });
        this.form.addEventListener('input', (_evt) =>{
            let invalidEle = this.form.querySelectorAll('.required-step.is-invalid');
            invalidEle.forEach(ele => ele.classList.remove('is-invalid'));
        });
        this.form.addEventListener('input', (_evt) =>{
            if (_evt.target.id == 'request-form-stone-type') {
                this.form.querySelector('[data-key="gemstone-shape"]').classList.add('d-none');
                this.form.querySelector('[data-key="gemstone-shape"]').classList.remove('required-step');    
            }
        });
        this.scrollToFormBtns.forEach(btn => {
            btn.addEventListener('click', (evt)=> {
                evt.preventDefault();
                this.form.scrollIntoView({ behavior: "smooth", block: "nearest"});
            });
        });
        
        if(this.datepicker){
            let lookForFlatpickr = setInterval(() => {
                if(typeof flatpickr == 'function'){
                    this.datepicker.flatpickr({
                        disableMobile: "true",
                        minDate: this.datepicker.min
                    });
                    clearInterval(lookForFlatpickr);
                } 
            }, 100);
        }
    }
    _showGemstoneOpt(){
        this.form.querySelector('[data-key="gemstone-shape"]').classList.remove('d-none');
        this.form.querySelector('[data-key="gemstone-shape"]').classList.add('required-step');
        
    }
    
    _validForSubmission(){
        const formData = new FormData(this.form);
        const requiredSteps = Array.from(this.form.querySelectorAll('.required-step'));        
        this.requiredKeys = requiredSteps.map(step => step.dataset.key).filter(key => key !== null);
        
        let validInputs = true;
        this.requiredKeys.forEach((key) => {
            let value = formData.get(key);
            let isValid = false;
            
            // Handle file inputs differently
            if (key === 'reference-image') {
                // Check if file is selected or if CDN URL is available
                const fileInput = this.form.querySelector(`[name="${key}"]`);
                const hasCdn = fileInput && fileInput.dataset.cdn;
                isValid =  hasCdn;
                
            } else {
                // Handle regular text inputs
                isValid = (value != null && value != undefined && value.toString().trim().length > 0);
            }
            
            if (!isValid) {
                validInputs = false;
                let element = this.form.querySelector(`[name="${key}"]`);
                
                
                if(element) {
                    let requiredStep = element.closest('.required-step');
                    if(requiredStep) {
                        requiredStep.classList.add('is-invalid');
                    }
                }
            }
        });

        if(!validInputs){            
            window.notificationEle.updateNotification('Input required!', 'Please fill in required details to submit the request.', {
                type: 'error',
                timeout: 10000
            });
            return false;
        }else if(!Utility.validateEmail(formData.get('email'))){
            window.notificationEle.updateNotification('Invalid email!', 'Please provide valid email', {
                type: 'error',
                timeout: 10000
            });
            return false;
        }

        return true;
    }

    async _submitForm(event){
        event.preventDefault();
        

        
        let formData = new FormData(this.form);
        let email = formData.get('email');
        let properties = {};

        if(!Utility.validateEmail(email)){
            window.notificationEle.updateNotification('Input required!', 'Please provide valid email to submit selection.', {
                type: 'error',
                timeout: 5000
            });
            return;
        }

        // Collect profile attributes
                let profileAttributes = {
                    email: formData.get('email'),
                    first_name: formData.get('first_name')
                };

                

                // Combine country code with phone number if available
                let phone = formData.get('phone_number');
                if (phone && phone.trim() !== '') {
                    let fullPhone = `${countryCode}${phone.trim()}`;
                    profileAttributes['phone_number'] = fullPhone;
                }

                // Collect custom design request event properties
                for (let [key, value] of formData.entries()) {
                    if (key == 'reference-image') {
                        value = this.form.querySelector('input[name="reference-image"]').dataset.cdn || '';
                    }

                    let current = properties[key];
                    if (
                        key != 'first_name' &&
                        key != 'last_name' &&
                        key != 'email' &&
                        key != 'phone_number' &&
                        key != 'country_code' &&
                        value != null
                    ) {
                        if (current === undefined) {
                            properties[key] = value.trim();
                        } else {
                            properties[key] = `${properties[key]},${value.trim()}`;
                        }
                    }
                }

    
        this.submitBtn.disabled = true;
        const eventData = {
            type: 'event',
            attributes: {
                properties: properties,
                metric: {data: {type: 'metric', attributes: {name: 'Whole sale form submitted'}}},
                profile: {
                    data: {
                        type: 'profile',
                        attributes: profileAttributes
                    }
                }
            }
        };

        try {
            let fetchResponse = await this._registerKlaviyoEvt(eventData);
            if(fetchResponse.ok){
                this.container.classList.add('show-thankyou-screen');   
                // this._trackConversion();
                this.thankyouScreen.scrollIntoView({ behavior: "smooth", block: "nearest"}); 
                this._addCustomerToList(formData.get('email'));
            }else{
                let errRes = (typeof fetchResponse == 'object') ? fetchResponse : JSON.parse(fetchResponse);
                let title = (errRes.errors) ? errRes.errors[0].title : 'Invalid Input';
                let detail = (errRes.errors) ? errRes.errors[0].detail : 'Provide valid details';
                window.notificationEle.updateNotification(title, detail, {
                    type: 'error',
                    timeout: 10000
                });
                this.submitBtn.removeAttribute('disabled');
            }
        }catch(error){
            console.log(error);
        }
    }

    async _registerKlaviyoEvt(eventData){
        const apiResponse = await fetch("https://a.klaviyo.com/client/events/?company_id=TfBnHa", {
            method: "POST",
            headers: {'revision': '2024-05-15', 'content-type': 'application/json', 'accept': 'application/json'},
            body: JSON.stringify({
                data: eventData
            })
        })

        if(!apiResponse.ok) {
            return apiResponse.text();
        }else {
           return (typeof apiResponse == 'object') ? apiResponse : apiResponse.json();
        } 
    }


    async _addCustomerToList(customerEmail){
        const senderData = {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: customerEmail
                  }
                }
              }
            },
            relationships: {list: {data: {type: 'list', id: 'Ws7h86'}}}
        }
        
        const apiResponse = await fetch("https://a.klaviyo.com/client/subscriptions/?company_id=TfBnHa", {
            method: "POST",
            headers: {'revision': '2024-05-15', 'content-type': 'application/json'},
            body: JSON.stringify({
                data: senderData
            })
        });

        return apiResponse;
    }
}
typeof customDesignForm !== 'undefined' && new customDesignForm();
